/**
 * Hook para transcrever áudio/vídeo de uma mensagem sob demanda (STT).
 *
 * O backend transcreve via Whisper e salva no plainText da mensagem
 * (idempotente — mensagem já transcrita retorna direto, sem custo).
 * Atualiza o cache infinito da conversa com o plainText resultante.
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { ConversationMessageResponse } from '@troia-v3/types';

export const useTranscribeMessage = () => {
  const queryClient = useQueryClient();

  return useMutation<ConversationMessageResponse, unknown, string>({
    mutationFn: async (messageId: string) => {
      const response = await api.post(`/conversation-messages/${messageId}/transcribe`);
      return response.data.data;
    },
    onSuccess: (message) => {
      queryClient.setQueriesData(
        { queryKey: ['messages', 'infinite', message.conversationId], exact: false },
        (oldData: any) => {
          if (!oldData?.pages) return oldData;

          return {
            ...oldData,
            pages: oldData.pages.map((page: any) => ({
              ...page,
              items: page.items.map((msg: any) =>
                msg.id === message.id ? { ...msg, plainText: message.plainText } : msg
              ),
            })),
          };
        }
      );
    },
  });
};
